<template>
  <div
    class="channel-include-condition-slot"
    :data-qa="`channel-include-slot-${channel}`"
  >
    <div class="channel-include-condition-slot__header">
      <h4 class="channel-include-condition-slot__title">{{ label }}</h4>
      <a
        v-if="enabled"
        class="channel-include-condition-slot__toggle"
        :data-qa="`channel-include-visibility-${channel}`"
        @click.prevent="conditionsVisible = !conditionsVisible"
      >
        {{
          conditionsVisible
            ? $t('ProjectSettings_ChannelIncludeCondition_HideConditions')
            : $t('ProjectSettings_ChannelIncludeCondition_ShowConditions')
        }}
      </a>
    </div>

    <toggle
      v-model="enabledModel"
      :text="$t('ProjectSettings_ChannelIncludeCondition_Enable')"
      :data-qa="`channel-include-toggle-${channel}`"
      :active-value="true"
      :inactive-value="false"
    />

    <conditions-editor
      class="m-top-20"
      ref="editor"
      v-if="enabled"
      v-show="conditionsVisible"
      :value="conditions"
      @input="onConditionsInput"
      :menu="menu"
      data-model-name="Segment"
      data-model-attribute="conditions"
      attribute-list-data-url="/segment/segment/attribute-list-data"
      :single-level="true"
    />
  </div>
</template>

<script>
import Toggle from '@/common/components/form/Toggle'
import ConditionsEditor from '@/common/components/ConditionsEditor'
import { emptyChannelConditions } from './channelIncludeConditions'

export default {
  name: 'ChannelIncludeConditionSlot',

  components: {
    Toggle,
    ConditionsEditor
  },

  props: {
    channel: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      required: true
    },
    conditions: {
      type: Object,
      default: () => emptyChannelConditions()
    },
    menu: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      conditionsVisible: true
    }
  },

  computed: {
    enabledModel: {
      get() {
        return this.enabled
      },
      set(value) {
        this.$emit('update:enabled', Boolean(value))
      }
    }
  },

  methods: {
    onConditionsInput(value) {
      this.$emit('update:conditions', value)
    },

    serialize() {
      if (!this.enabled) {
        return null
      }
      return this.$refs.editor ? this.$refs.editor.serialize() : null
    },

    validate() {
      if (!this.enabled || !this.$refs.editor) {
        return []
      }
      return this.$refs.editor.validateConditions()
    }
  }
}
</script>

<style scoped>
.channel-include-condition-slot {
  border: 1px solid #dbdee7;
  border-radius: 3px;
  padding: 16px 20px;
  margin-bottom: 12px;
  background-color: #fff;
}
.channel-include-condition-slot__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.channel-include-condition-slot__title {
  margin: 0;
  font-weight: 600;
}
.channel-include-condition-slot__toggle {
  color: #1e88e5;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/ChannelIncludeConditionSlot.vue